import React, { useState } from "react";
import "./CartDrawer.css";

const CartDrawer = ({ open, setOpen, cartItems, setCartItems }) => {
  const [customer, setCustomer] = useState({
    name: "",
    mobile: "",
    address: "",
  });

  
  const updateQty = (id, qty) => {
    if (qty < 1) return;
    setCartItems(
      cartItems.map((x) => (x.id === id ? { ...x, qty } : x))
    );
  };

 
  const removeItem = (id) => {
    setCartItems(cartItems.filter((x) => x.id !== id));
  };

  
  const subtotal = cartItems.reduce((a, c) => a + c.price * c.qty, 0);
  const gst = subtotal * 0.18;
  const grandTotal = subtotal + gst;


  const handleOrder = async () => {
  const orderData = {
    customer_name: customer.name,
    customer_phone: customer.mobile,
    address: customer.address,
    items: cartItems.map(item => ({
      product_id: item.id,
      name: item.name,
      quantity: item.qty,
      price: item.price
    })),
    total_amount: grandTotal
  };

  try {
    const response = await fetch('https://api.rpsmartsolar.in/api/place-order/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    });

    if (response.ok) {
      alert("Order stored in Database successfully!");
      
      const phoneNumber = "919994356072";
      const productLines = cartItems
        .map(item => `${item.name} x ${item.qty} = ₹${(item.price * item.qty).toFixed(2)}`)
        .join("%0A");
      const message = `🛒 *New Order Stored*%0A...`; 

      window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
      
      setCartItems([]);
      setOpen(false);
    } else {
      alert("Failed to store order. Please try again.");
    }
  } catch (error) {
    console.error("Error placing order:", error);
    alert("Server connect aagala! Check your backend.");
  }
};
if (!open) return null;
  return (
    <div className="drawer-overlay">
      <div className="drawer-panel">
        <div className="drawer-header">
          <h2>Your Cart</h2>
          <div className="drawer-actions">
          <button className="drawer-minimize" onClick={() => setOpen(false)}>–</button>
          <button className="drawer-close" onClick={() => setOpen(false)}>✕</button>
        </div>
        </div>

        <div className="drawer-content">
          {cartItems.length === 0 ? (
            <p>Your cart is empty.</p>
          ) : (
            <>
              {cartItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <img src={item.image} alt={item.name} />
                  <div className="cart-item-details">
                    <h4>{item.name}</h4>
                    <p>₹{item.price}</p>
                    <div className="qty-controls">
                      <button onClick={() => updateQty(item.id, item.qty - 1)}>-</button>
                      <span>{item.qty}</span>
                      <button onClick={() => updateQty(item.id, item.qty + 1)}>+</button>
                    </div>
                  </div>
                  <button className="remove" onClick={() => removeItem(item.id)}>✕</button>
                </div>
              ))}

              <div className="totals">
                <div className="line"><span>Subtotal</span><span>₹{subtotal.toFixed(2)}</span></div>
                <div className="line"><span>GST (18%)</span><span>₹{gst.toFixed(2)}</span></div>
                <div className="line grand"><span>Total</span><span>₹{grandTotal.toFixed(2)}</span></div>
              </div>

              <div className="form">
                <input type="text" placeholder="Your Name"
                  value={customer.name}
                  onChange={(e) => setCustomer({ ...customer, name: e.target.value })}
                />
                <input type="tel" placeholder="Mobile Number"
                  value={customer.mobile}
                  onChange={(e) => setCustomer({ ...customer, mobile: e.target.value })}
                />
                <textarea placeholder="Shipping Address"
                  value={customer.address}
                  onChange={(e) => setCustomer({ ...customer, address: e.target.value })}
                />
              </div>
            </>
          )}
        </div>

        {cartItems.length > 0 && (
          <div className="drawer-footer">
            <button
              className="btn-primary"
              onClick={handleOrder}
              disabled={!customer.name || !customer.mobile || !customer.address}
            >
              Place Order on WhatsApp
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;